import * as api from './services/api';
import * as blockui from '../helpers/block-ui';

export default {
  props: ['token'],
  data() {
    return {
      // null = token kontrol ediliyor, true = geçerli (form göster), false = geçersiz/kullanılmış (mesaj göster)
      tokenValid: null,
    };
  },
  mounted() {
    const self = this;
    if (!self.token) {
      self.tokenValid = false;
      return;
    }
    api.validateResetToken(self.token).then((res) => {
      self.tokenValid = !!(res.body && res.body.IsSuccess);
      if (self.tokenValid) {
        self.$nextTick(() => {
          window.$('form').validate();
        });
      }
    }, () => {
      self.tokenValid = false;
    });
  },
  methods: {
    onSubmit(e) {
      const self = this;
      e.preventDefault();
      const form = $(e.target);
      if (form.valid()) {
        const formData = {};
        blockui.pageBlock(self);
        $.map(form.serializeArray(), (item) => {
          Object.assign(formData, { [item.name]: item.value });
        });
        Object.assign(formData, { token: self.token });
        api.resetPassword(formData).then((res) => {
          blockui.unBlockPage();
          if (res.body.IsSuccess) {
            toastr.success(this.translate('password_changed'));
            window.location = '#/Login';
          } else {
            toastr.warning(res.body.Message);
          }
        }, (error) => {
          blockui.unBlockPage();
        });
      }
    },
  },
};
